export default "__VITE_ASSET__CuAGBtx9__"